<ng-container *ngIf="integrations$ | async"></ng-container>
<div class="wizard-import">
  <h5 class="wizard-heading-1">Import Courses</h5>
  <ng-container *ngIf="isLoading; else main">
    <div class="wizard-import-loading-container">
      <i class="fas fa-spinner fa-spin" style="font-size: 22px"></i>
    </div>
  </ng-container>
  <ng-template #main>
    <ng-container *ngIf="!integrations?.length; else selection">
      <p class="wizard-content">
        No integrations to select from. Please create one to start the process
      </p></ng-container
    >
    <ng-template #selection>
      <p class="wizard-content">
        Select how courses will be imported. These methods will be used
        independently of each other when set.
      </p>
      <div
        class="wizard-import-select-container"
        *ngIf="integrations.length && integrations?.length !== 1"
      >
        <label>Select Integration to Import With</label>
        <nb-select
          class="wizard-import-select"
          (selectedChange)="updateSelectedIntegration($event)"
          [placeholder]="'Select Integration'"
          [value]="selectedIntegration"
        >
          <nb-option
            *ngFor="let integration of integrations"
            [value]="integration"
            >{{
              integration?.value?.friendly_name || integration?.value?.name
            }}</nb-option
          >
        </nb-select>
      </div>
      <ng-container *ngIf="selectedIntegration">
        <ng-container *ngIf="selectedIntegrationError; else tabs">
          <h5 class="wizard-import-error-message wizard-heading-1">
            {{ selectedIntegrationErrorMessage }}
          </h5>
        </ng-container>
        <ng-template #tabs>
          <nb-tabset>
            <nb-tab [tabTitle]="'terms' | translation">
              <app-wizard-terms></app-wizard-terms>
            </nb-tab>
            <nb-tab [tabTitle]="'course_code' | translation">
              <app-wizard-course-code></app-wizard-course-code>
            </nb-tab>
            <!-- <nb-tab [tabTitle]="'Date Range' | translation">
              <app-wizard-date-range></app-wizard-date-range>
            </nb-tab> -->
          </nb-tabset>
          <div class="wizard-button-container">
            <button
              [disabled]="!changes"
              nbButton
              ghost
              class="text-link-color"
              (click)="saveImportInfo()"
            >
              <i
                class="fa-light fa-floppy-disk text-link-color"
                style="margin-right: 10px"
              ></i>
              <span
                *ngIf="
                  changes === 'updated' || changes === 'addition';
                  else save
                "
              >
                Save And Import
              </span>
              <ng-template #save><span>Save</span></ng-template>
            </button>
          </div>
        </ng-template>
      </ng-container>
    </ng-template>
  </ng-template>
</div>
